import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'antd';

interface AutoTooltipProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    tooltipPlacement?: 'topLeft' | 'top' | 'topRight' | 'bottomLeft' | 'bottom' | 'bottomRight';
    className?: string;
    style?: React.CSSProperties;
}

export const AutoTooltip = ({
    children,
    tooltipPlacement = 'topLeft',
    className = '',
    style = {},
    ...props
}: AutoTooltipProps) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipContent, setTooltipContent] = useState<string>('');

    const checkOverflow = () => {
        const el = contentRef.current;
        if (!el) return;

        const isOverflowing = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
        setShowTooltip(isOverflowing);

        if (isOverflowing) {
            setTooltipContent(el.textContent?.trim() || '');
        }
    };

    useEffect(() => {
        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [children]);

    return (
        <Tooltip
            title={tooltipContent}
            placement={tooltipPlacement}
            open={showTooltip ? undefined : false} // Prevents flickering
        >
            <div
                ref={contentRef}
                className={`truncate ${className}`}
                style={style}
                {...props}
                onMouseEnter={checkOverflow}
            >
                {children}
            </div>
        </Tooltip>
    );
};

export default AutoTooltip;
